import React from 'react';
import { images } from '@assets/img';

const ImageComponent = ({ className, style, src = images.logo, alt = 'image', onClick }) => {
	return <img alt={alt} className={className} style={style} src={src} onError={() => images.logo} onClick={onClick} />;
};

export default ImageComponent;
